import EmblaCarousel from 'embla-carousel';

const FeaturedCollectionCarousel = () => {
  const viewport = document.querySelector('.featured-collection-carousel__viewport');
  const prevButton = document.querySelector('.featured-collection-carousel__control.--prev');
  const nextButton = document.querySelector('.featured-collection-carousel__control.--next');

  if (!viewport) {
    return;
  }

  const embla = EmblaCarousel(viewport, {
    loop: true,
    slidesToScroll: 1,
    resize: true,
    align: 'start',
    skipSnaps: true,
    draggable: true,
  });

  prevButton?.addEventListener('click', () => embla.scrollPrev());
  nextButton?.addEventListener('click', () => embla.scrollNext());
};

export default FeaturedCollectionCarousel;
